import type { ApiUserEnvironment } from '#/api/userEnvironment/types/ApiUserEnvironment';
import type { NonNullableFields } from '#/types/NonNullableFields';
import { postJson } from '#/utils/http/postJson';
import { putJson } from '#/utils/http/putJson';

import type { VMPostVerificationPUTPayload } from './types';

type ApiVMOnboardingUserInfoPayload = VMPostVerificationPUTPayload;

type ApiVMOnboardingUserInfoResponse = {
  userEnvironment: NonNullableFields<ApiUserEnvironment>;
};

export async function apiUpdateVMOnboardingUserInfo(
  payload: ApiVMOnboardingUserInfoPayload,
): Promise<ApiVMOnboardingUserInfoResponse> {
  return putJson<ApiVMOnboardingUserInfoResponse>(
    '/data/vm-onboarding/user-info',
    payload,
  );
}

export async function apiMarkUserAsOnboarded(): Promise<ApiUserEnvironment> {
  return postJson<ApiUserEnvironment>('/data/vm-onboarding/done');
}
